var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FA3079",
    d: "M.1 24.755v-4.001h32v4.001H.1zm0-14.001h32v4H.1v-4zM.1.753h32v4.001H.1V.753z"
  })));
};
export { SvgBurger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyNSI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNGQTMwNzkiIGQ9Ik0uMSAyNC43NTV2LTQuMDAxaDMydjQuMDAxSC4xem0wLTE0LjAwMWgzMnY0SC4xdi00ek0uMS43NTNoMzJ2NC4wMDFILjFWLjc1M3oiLz4KPC9zdmc+Cg==";